import { render, staticRenderFns } from "./CompanyUserDeleteScreen.vue?vue&type=template&id=8e28437a&scoped=true&lang=pug"
import script from "./CompanyUserDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./CompanyUserDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./CompanyUserDeleteScreen.vue?vue&type=style&index=0&id=8e28437a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e28437a",
  null
  
)

export default component.exports